export const environment = {
  production: false,
  warMode: false,
  env: 'dev',
  version: '1.0',
  baseUrl: 'https://api-mcc-php.syntonize.dev/api/web',
  apiUrl: 'https://api-mcc-php.syntonize.dev/api',
  apiEnvDomain: 'https://api-mcc-php.syntonize.dev',
  trackingUrl: 'https://api-mcc-php.syntonize.dev/api/tracking',
  tenantByUrl: {
    'localhost:4200': 'marineda',
    'almada.syntonize.dev': 'almada',
    'marineda.syntonize.dev': 'marineda',
    'arenas.syntonize.dev': 'arenas',
    'artea.syntonize.dev': 'artea',
    'arturo.syntonize.dev': 'arturo',
    'saler.syntonize.dev': 'saler',
    'fira.syntonize.dev': 'fira',
    'vital.syntonize.dev': 'vital',
    'larios.syntonize.dev': 'larios',
    'porto.syntonize.dev': 'porto',
    'thader.syntonize.dev': 'thader',
    'tresaguas.syntonize.dev': 'tresaguas'
  },
  tenants: {
    almada: {
      metadata: {
        title: 'Home - Almada Forum',
        description: '',
      },
      blogUrl: 'https://blog.almadaforum.com',
      allowedLanguages: ['PT', 'EN'],
      hasCinema: true,
      hasOnlyRestoration: true,
      zoomLevel: 19,
      shouldFitToBounds: true,
      situm: {
        user: 'almada@merlinproperties.com',
        key: '856e36d8bb1cb4ccb5a3e3cd171757b717df7b0bcec999cd559a2eb305d1b629',
        iframe: 'merlin_cc_almada',
      },
      footerLogoURL: 'https://www.merlinproperties.com/',
      fidelityCardName: 'Shopping Lovers Gift Card',
      fidelityCardUrl: 'shopping-lovers-gift-card',
      cookieScript:{
        id:"Cookiebot",
        src:"https://consent.cookiebot.com/uc.js",
        cbid: "19d2483e-83d2-47b0-8b61-62ff30d75b86",
        blockingmode:"auto",
      },
      cookieDeclarationScript:{
        id:"CookieDeclaration",
        src:"https://consent.cookiebot.com/19d2483e-83d2-47b0-8b61-62ff30d75b86/cd.js",
      }
    },
    arenas: {
      metadata: {
        title: 'Centre Comercial Arenas de Barcelona | Barcelona',
        description: '',
      },
      blogUrl: 'https://blog.arenasdebarcelona.com',
      allowedLanguages: ['CA', 'ES', 'EN'],
      hasCinema: true,
      zoomLevel: 20,
      shouldFitToBounds: false,
      situm: {
        user: 'arenas@merlinproperties.com',
        key: 'ed202960e5e30e751c5afc31118f82768cc89ae2eda58c4feeb7f730a0923566',
       iframe: 'merlin_cc_arenas',
      },
      footerLogoURL: 'https://www.merlinproperties.com/',
      fidelityCardName: 'Tarjeta Arenas Community',
      fidelityCardUrl: 'tarjeta-arenas-community',
      isActiveLanding: false,
      cookieScript:{
        id:"Cookiebot",
        src:"https://consent.cookiebot.com/uc.js",
        cbid: "22df69cd-956b-4ba0-81db-d3f02a1e9978",
        blockingmode:"auto",
      },
      cookieDeclarationScript:{
        id:"CookieDeclaration",
        src:"https://consent.cookiebot.com/22df69cd-956b-4ba0-81db-d3f02a1e9978/cd.js",
      }
    },
    artea: {
      metadata: {
        title: 'Artea | Vizcaya',
        description:
          'Barrio Peruri, 33 48940 Leioa Vizcaya. 944912706 · clientes@arteanet.com. Información práctica. Tiendas. Ocio/Restauración. Cines. Promociones. Mapas.',
      },
      blogUrl: 'https://blog.arteanet.com',
      allowedLanguages: ['ES', 'EU'],
      hasCinema: true,
      zoomLevel: 19,
      shouldFitToBounds: true,
      situm: {
        user: 'artea@merlinproperties.com',
        key: '1919343f07b0cde2b4ef579eb4392315ccad70fbaf3e3ff717d3880894164854',
        iframe: 'merlin_cc_artea',
      },
      footerLogoURL: 'https://www.merlinproperties.com/',
      fidelityCardName: 'Club VIP Artea',
      fidelityCardUrl: 'club-vip-artea',
      gtm_id: 'GTM-MTKTFVL',
      isActiveLanding: false,
      cookieScript:{
        id:"Cookiebot",
        src:"https://consent.cookiebot.com/uc.js",
        cbid: "15de384b-6a03-4ccc-ad28-a8ad6feb090e",
        blockingmode:"auto",
      },
      cookieDeclarationScript:{
        id:"CookieDeclaration",
        src:"https://consent.cookiebot.com/15de384b-6a03-4ccc-ad28-a8ad6feb090e/cd.js",
      }
    },
    arturo: {
      metadata: {
        title: 'Centro Comercial Arturo Soria | Madrid',
        description: '',
      },
      blogUrl: 'https://blog.arturosoriaplaza.es',
      allowedLanguages: ['ES', 'EN'],
      hasCinema: false,
      hasOnlyRestoration: true,
      zoomLevel: 19,
      shouldFitToBounds: true,
      situm: {
        user: 'asoria@merlinproperties.com',
        key: '0c1f19ad7810be014f932469b8f45f156dbfde98f311307f9337d81e465d55c6',
        iframe: 'merlin_cc_arturosoria',
      },
      footerLogoURL: 'https://www.merlinproperties.com/',
      fidelityCardName: 'Club VIP',
      fidelityCardUrl: 'club-vip',
      isActiveLanding: false,
      cookieScript:{
        id:"Cookiebot",
        src:"https://consent.cookiebot.com/uc.js",
        cbid: "6a3046f8-ab73-4578-a0e5-00c2c6812b0a",
        blockingmode:"auto",
      },
      cookieDeclarationScript:{
        id:"CookieDeclaration",
        src:"https://consent.cookiebot.com/6a3046f8-ab73-4578-a0e5-00c2c6812b0a/cd.js",
      }
    },
    saler: {
      metadata: {
        title: 'Centro Comercial CC El Saler | Valencia',
        description: '',
      },
      blogUrl: 'https://blog.elsaler.com',
      allowedLanguages: ['ES'],
      hasCinema: true,
      zoomLevel: 19,
      shouldFitToBounds: true,
      situm: {
        user: 'elsaler@merlinproperties.com',
        key: 'cefd3bfae1f9c782c49984889279735f6969d8515bd082be7d7ebb954efdf780',
        iframe: 'merlin_cc_elsaler',
      },
      footerLogoURL: 'https://www.merlinproperties.com/',
      fidelityCardName: 'Tarjeta de fidelización',
      fidelityCardUrl: 'tarjeta-de-fidelizacion',
      isActiveLanding: false,
      cookieScript:{
        id:"Cookiebot",
        src:"https://consent.cookiebot.com/uc.js",
        cbid: "6ead69c4-a098-4cc8-aad3-dc392814d2e3",
        blockingmode:"auto",
      },
      cookieDeclarationScript:{
        id:"CookieDeclaration",
        src:"https://consent.cookiebot.com/6ead69c4-a098-4cc8-aad3-dc392814d2e3/cd.js",
      }
    },
    fira: {
      metadata: {
        title: 'Centre Comercial La Fira | Reus',
        description: '',
      },
      blogUrl: 'https://blog.lafiracentrecomercial.com',
      allowedLanguages: ['CA', 'ES'],
      hasCinema: true,
      zoomLevel: 19,
      shouldFitToBounds: true,
      situm: {
        user: 'lafira@merlinproperties.com',
        key: 'cd012d6831a6e4a7a0faf6a4a47cbaf9714e54153d22e2da4d622fa51efce54a',
        iframe: '',
      },
      footerLogoURL: 'https://www.socimisilicius.com/',
      fidelityCardName: 'La Fira Club Card',
      fidelityCardUrl: 'la-fira-club-card',
    },
    vital: {
      metadata: {
        title: 'Centro Comercial La Vital | Gandia',
        description: '',
      },
      blogUrl: 'https://blog.lavital.es',
      allowedLanguages: ['ES', 'VA'],
      hasCinema: true,
      hasOnlyRestoration: true,
      zoomLevel: 19,
      shouldFitToBounds: true,
      situm: {
        user: 'lavital@merlinproperties.com',
        key: '4d848e93e7cfe48c25abf03899fc1f781a1f69e31ba1e49b74e995b049f3bb31',
        iframe: 'merlin_cc_lavital'
      },
      footerLogoURL: 'https://www.merlinproperties.com/',
      fidelityCardName: 'VITAL CARD',
      fidelityCardUrl: 'vital-card',
      isActiveLanding: false,
      cookieScript:{
        id:"Cookiebot",
        src:"https://consent.cookiebot.com/uc.js",
        cbid: "4fee4bb8-8967-4c85-a13f-c2af9a0292b9",
        blockingmode:"auto",
      },
      cookieDeclarationScript:{
        id:"CookieDeclaration",
        src:"https://consent.cookiebot.com/4fee4bb8-8967-4c85-a13f-c2af9a0292b9/cd.js",
      }
    },
    larios: {
      metadata: {
        title: 'Centro Comercial Larios Centro | Málaga',
        description: '',
      },
      blogUrl: 'https://blog.larioscentro.com',
      allowedLanguages: ['ES', 'EN', 'FR'],
      hasCinema: false,
      zoomLevel: 19,
      shouldFitToBounds: true,
      situm: {
        user: 'larios@merlinproperties.com',
        key: '000c32897013653157c15014e6657d3055100d2719547feb37596941306c09d9',
       iframe: 'merlin_cc_larios',
      },
      footerLogoURL: 'https://www.merlinproperties.com/',
      hasOnlyRestoration: true,
      fidelityCardName: 'Larios Card',
      fidelityCardUrl: 'larios-card',
      isActiveLanding: true,
      cookieScript:{
        id:"Cookiebot",
        src:"https://consent.cookiebot.com/uc.js",
        cbid: "1e51390d-b7ae-40c6-a701-07e104668f5c",
        blockingmode:"auto",
      },
      cookieDeclarationScript:{
        id:"CookieDeclaration",
        src:"https://consent.cookiebot.com/1e51390d-b7ae-40c6-a701-07e104668f5c/cd.js",
      }
    },
    marineda: {
      metadata: {
        title: 'Marineda City | A Coruña',
        description:
          'Moda, entretenimiento, restaurantes y mucho más, en el mayor centro comercial de Galicia. IKEA, Mediamarkt, Primark, Inditex, bolos, karting, cines… Todo en Marineda City.',
      },
      blogUrl: 'https://blog.marinedacity.com',
      blogHasCustomPlugin: true,
      allowedLanguages: ['ES', 'GL'],
      hasCinema: true,
      hasNoSubcategories: true,
      zoomLevel: 19,
      shouldFitToBounds: true,
      situm: {
        user: 'merlinproperties@situm.es',
        key: '14285e6340a890d0af61de698469a3319ed52fa9f42a7bfe109914ff1889b290',
        iframe: 'merlin_cc_marineda',
      },
      footerLogoURL: 'https://www.merlinproperties.com/',
      gtm_id: 'GTM-K6FRP34',
      fidelityCardName: 'CITYCARD',
      fidelityCardUrl: 'citycard',
      isActiveLanding: true,
      cookieScript:{
        id:"Cookiebot",
        src:"https://consent.cookiebot.com/uc.js",
        cbid: "81eaa9bb-d09c-44be-8465-3e2274a1f6c2",
        blockingmode:"auto",
      },
      cookieDeclarationScript:{
        id:"CookieDeclaration",
        src:"https://consent.cookiebot.com/81eaa9bb-d09c-44be-8465-3e2274a1f6c2/cd.js",
      }
    },
    porto: {
      metadata: {
        title: 'Centro Comercial Porto Pi Centro | Palma de Mallorca',
        description: '',
      },
      blogUrl: 'https://blog.portopicentro.es',
      allowedLanguages: ['ES', 'EN', 'CA', 'DE'],
      hasCinema: true,
      zoomLevel: 19,
      shouldFitToBounds: true,
      situm: {
        user: 'portopi@merlinproperties.com',
        key: 'ca1485386cb3879e20c0ca4fec5390f0298433185f86f3dc4ac63b5ae8e4e3b7',
        iframe: 'merlin_cc_portopi',
      },
      footerLogoURL: 'https://www.merlinproperties.com/',
      isActiveLanding: false,
      cookieScript:{
        id:"Cookiebot",
        src:"https://consent.cookiebot.com/uc.js",
        cbid: "779ec2df-6ca4-495c-89b3-1d3248d94bb3",
        blockingmode:"auto",
      },
      cookieDeclarationScript:{
        id:"CookieDeclaration",
        src:"https://consent.cookiebot.com/779ec2df-6ca4-495c-89b3-1d3248d94bb3/cd.js",
      }
    },
    thader: {
      metadata: {
        title: 'Centro Comercial Thader | Murcia',
        description: '',
      },
      blogUrl: 'https://blog.thader.net',
      allowedLanguages: ['ES'],
      hasCinema: true,
      zoomLevel: 19,
      shouldFitToBounds: true,
      situm: {
        user: 'thader@merlinproperties.com',
        key: '8b25f2f1984af39a935b3ed323b55d7d09d9d1d768efcd548882f3c4eb8c2e88',
        iframe: '',
      },
      footerLogoURL: 'https://www.socimisilicius.com/',
      fidelityCardName: 'MÁS THADER',
      fidelityCardUrl: 'mas-thader',
    },
    tresaguas: {
      metadata: {
        title: 'Centro Comercial TresAguas | Alcorcón',
        description: '',
      },
      blogUrl: 'https://blog.tresaguas.es',
      allowedLanguages: ['ES'],
      hasCinema: true,
      zoomLevel: 19,
      shouldFitToBounds: true,
      situm: {
        user: 'tresaguas@merlinproperties.com',
        key: 'c62eea8f328e21a285c328f2e39204f40e15a9482a562d2f40995b5cbb734edb',
        iframe: 'merlin_cc_tresaguas',
      },
      footerLogoURL: 'https://www.merlinproperties.com/',
      fidelityCardName: 'TRES AGUAS PLUS',
      fidelityCardUrl: 'tres-aguas-plus',
      isActiveLanding: false,
      cookieScript:{
        id:"Cookiebot",
        src:"https://consent.cookiebot.com/uc.js",
        cbid: "929beaa5-e922-4563-897e-8cea0a84db4b",
        blockingmode:"auto",
      },
      cookieDeclarationScript:{
        id:"CookieDeclaration",
        src:"https://consent.cookiebot.com/929beaa5-e922-4563-897e-8cea0a84db4b/cd.js",
      }
    }
  },
};
